import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'
import { IMultiBankPosInsatallment } from '../models/models'

export class AddMultiBankParatikaPosInsatallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransactionParatika/addMultiBankParatikaPosInsatallment',
      requesterInfo,
    })
  }

  public async addMultiBankParatikaPosInsatallment(request: IMultiBankPosInsatallment): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}
